<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Dados do Comunicante</b>
      </div>
      <div class="row g-3">
        <div
          class="col-md-6"
          :class="{
            'field-required':
              validation &&
              validation.ComunicanteContacto &&
              validation.ComunicanteContacto.ParentescoId &&
              validation.ComunicanteContacto.ParentescoId.$invalid
          }"
        >
          <label class="form-label">Vínculo com o segurado</label>
          <Dropdown
            v-model="comunicante.ParentescoId"
            :options="vinculos"
            option-value="Id"
            option-label="Description"
            placeholder="Selecione"
            class="form-control p-0"
            @change="vinculoChange"
          />
        </div>
        <div class="col-md-6">
          <label for="nome_comunicante" class="form-label">Nome completo</label>
          <InputText
            id="nome_comunicante"
            v-model="comunicante.Nome"
            disabled
            class="form-control"
          />
        </div>

        <div class="col-md-6">
          <label for="cpf_comunicante" class="form-label">CPF</label>
          <InputMask
            id="cpf_comunicante"
            v-model="comunicante.NrContribuinte"
            mask="999.999.999-99"
            :unmask="true"
            disabled
            class="form-control"
          />
        </div>
        <div class="col-md-6">
          <label for="email_comunicante" class="form-label">Email</label>
          <InputText
            id="email_comunicante"
            v-model="comunicante.Email"
            disabled
            class="form-control"
          />
        </div>

        <div class="col-md-6">
          <TelefoneInput
            id="telefone_comunicante"
            v-model="comunicante.Telefone"
            label="Telefone fixo"
            force-type="fixo"
            :disabled="true"
          />
        </div>
        <div class="col-md-6">
          <TelefoneInput
            id="telemovel_comunicante"
            v-model="comunicante.Telemovel"
            label="Telefone celular"
            force-type="celular"
            :disabled="true"
          />
        </div>

        <div class="col-md-6">
          <label class="form-label" for="morada_comunicante"> Endereço Residencial </label>
          <InputText
            id="morada_comunicante"
            v-model="comunicante.Morada"
            disabled
            class="form-control"
          />
        </div>
        <div
          class="col-md-6"
          :class="{
            'field-required':
              validation &&
              validation.Servico &&
              validation.Servico.ServicoComplementoPeriodoDiaId &&
              validation.Servico.ServicoComplementoPeriodoDiaId.$invalid
          }"
        >
          <label class="form-label">Melhor Horário de Contato</label>
          <Dropdown
            v-model="servico.ServicoComplementoPeriodoDiaId"
            :options="periodoDia"
            option-value="Id"
            option-label="Description"
            placeholder="Selecione"
            class="form-control p-0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getContactRelation, getPeriodoDia } from '../api/formMethods';
  import { filtrosVinculo } from '../utils/constants';
  import TelefoneInput from '@/components/inputs/TelefoneInput.vue';
  import Dropdown from 'primevue/dropdown';
  import InputText from 'primevue/inputtext';
  import InputMask from 'primevue/inputmask';

  export default {
    components: {
      TelefoneInput,
      Dropdown,
      InputText,
      InputMask
    },
    props: {
      comunicante: {
        type: Object,
        default: () => ({})
      },
      servico: {
        type: Object,
        default: () => ({})
      },
      validation: {
        type: Object,
        default: () => ({
          ComunicanteContacto: { ParentescoId: { $invalid: false } },
          Servico: { ServicoComplementoPeriodoDiaId: { $invalid: false } }
        })
      }
    },
    data() {
      return {
        vinculos: [],
        periodoDia: []
      };
    },
    async mounted() {
      const res = await getContactRelation();
      this.vinculos = res.filter(({ Id }) => filtrosVinculo.includes(Id));

      this.periodoDia = await getPeriodoDia();

      const comunicanteStore = this.$store.getters.getComunicanteContacto;
      if (comunicanteStore && this.comunicante) {
        const { nome, cpf, email, morada, telefone, telemovel } = comunicanteStore;

        this.comunicante.Nome = nome || '';
        this.comunicante.Email = email || '';
        this.comunicante.Telefone = telefone || '';
        this.comunicante.Telemovel = telemovel || '';
        this.comunicante.NrContribuinte = cpf || '';
        this.comunicante.Morada = morada || '';
      }
    },
    methods: {
      vinculoChange() {
        const comunicanteStore = this.$store.getters.getComunicanteContacto;
        if (comunicanteStore) {
          this.$emit('vinculoChange', comunicanteStore);
        }
      }
    }
  };
</script>
